export const SIGNATURES_ATTENTION_COUNT = 10;
export const OCR_ATTENTION_COUNT = 10;

export const TRIAL_DAYS = 7;
export const ORG_INN_LENGTH = 10;
export const IP_INN_LENGTH = 12;
export const ORG_OGRN_LENGTH = 13;
export const IP_OGRN_LENGTH = 15;
export const ORG_KPP_LENGTH = 9;

export const FORMA_FOLDER_ID_STATIC = 'main';
export const FORMA_FOLDER_ID_PACKS = 'packs';
export const FORMA_FOLDER_ID_STRICT = 'strict';
export const FORMA_FOLDER_ID_TRASH = 'trash';
export const FORMA_FOLDER_ID_BACK = 'back';

export const SECRET_TARIFF_ID = 'tariff_secret';
export const TRIAL_TARIFF_ID = 'tariff_trial';
export const START_TARIFF_ID = 'tariff_start';
export const TEAM_TARIFF_ID = 'tariff_team';
export const POPULAR_TARIFF_ID = 'tariff_team';

export const CRYPTORO_ERRORS = ['0x8007065B'];
export const DEFAULT_TARIFF_ID = 'tariff_team';
export const DEFAULT_TARIFF_DURATION = 90;

export const PARTNERSHIP_DEBT_PERCENT = 20;

export const USER_AVATAR = '/images/avatar-placeholder.svg';
